import { queryOptions } from "@tanstack/react-query";
import { GeneratedFileService } from "../service/GeneratedFileService";

const generatedFileQueries = {
  all: (spaceId?: string) =>
    queryOptions({
      queryKey: spaceId
        ? ["generated-files", spaceId]
        : ["generated-files"],
      queryFn: () => GeneratedFileService.getAll({ spaceId }),
    }),
};

export { generatedFileQueries };
